/* Official ZION mark — concept #430 (dashed ring + Z monogram).
   Uses currentColor so it adapts to wherever it's placed. */
const FONT = "'JetBrains Mono','Segoe UI',Helvetica,Arial,sans-serif";

const ZionLogo = ({ size = 28, strokeWidth = 6, className, style }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    style={style}
    role="img"
    aria-label="ZION"
    fill="none"
  >
    <circle
      cx="32"
      cy="32"
      r="24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeDasharray="6 8"
      strokeLinecap="round"
    />
    <text
      x="32"
      y="34"
      textAnchor="middle"
      dominantBaseline="central"
      fontFamily={FONT}
      fontWeight="800"
      fontSize="26"
      fill="currentColor"
    >
      Z
    </text>
  </svg>
);

export default ZionLogo;
